export const isRangeInFullWeeks = (
  date1: Date,
  date2: Date
) =>
  DateFns.isSameDay(date1, DateFns.startOfISOWeek(date1)) &&
  DateFns.isSameDay(date2, DateFns.endOfISOWeek(date2))

export const isRangeInFullMonths = (
  date1: Date,
  date2: Date
) =>
  DateFns.isSameDay(date1, DateFns.startOfMonth(date1)) &&
  DateFns.isSameDay(date2, DateFns.endOfMonth(date2))

export const isRangeInFullYears = (
  date1: Date,
  date2: Date
) =>
  DateFns.isSameDay(date1, DateFns.startOfYear(date1)) &&
  DateFns.isSameDay(date2, DateFns.endOfYear(date2))

export const getLabelForRange = (
  date1: Date,
  date2: Date
) => {
  if (isRangeInFullYears(date1, date2)) {
    if (
      DateFns.isThisYear(date1) &&
      DateFns.isThisYear(date2)
    ) {
      return "This Year"
    } else if (
      DateFns.isSameYear(
        date1,
        DateFns.addYears(new Date(), 1)
      ) &&
      DateFns.isSameYear(
        date2,
        DateFns.addYears(new Date(), 1)
      )
    ) {
      return "Next Year"
    } else if (
      DateFns.isSameYear(
        date1,
        DateFns.addYears(new Date(), -1)
      ) &&
      DateFns.isSameYear(
        date2,
        DateFns.addYears(new Date(), -1)
      )
    ) {
      return "Last Year"
    } else if (DateFns.isSameYear(date1, date2)) {
      return DateFns.format(date1, "yyyy")
    } else {
      return `${DateFns.format(
        date1,
        "yyyy"
      )} - ${DateFns.format(date2, "yyyy")}`
    }
  } else if (isRangeInFullMonths(date1, date2)) {
    // Date range is a month
    if (
      DateFns.isThisMonth(date1) &&
      DateFns.isThisMonth(date2)
    ) {
      return "This Month"
    } else if (
      DateFns.isSameMonth(
        date1,
        DateFns.addMonths(new Date(), 1)
      ) &&
      DateFns.isSameMonth(
        date2,
        DateFns.addMonths(new Date(), 1)
      )
    ) {
      return "Next Month"
    } else if (
      DateFns.isSameMonth(
        date1,
        DateFns.addMonths(new Date(), -1)
      ) &&
      DateFns.isSameMonth(
        date2,
        DateFns.addMonths(new Date(), -1)
      )
    ) {
      return "Last Month"
    } else if (DateFns.isSameMonth(date1, date2)) {
      return DateFns.format(date1, "MMM yyyy")
    } else {
      return `${DateFns.format(
        date1,
        "MMM yyyy"
      )} - ${DateFns.format(date2, "MMM yyyy")}`
    }
  } else if (isRangeInFullWeeks(date1, date2)) {
    // Date range is a week
    if (
      DateFns.isThisISOWeek(date1) &&
      DateFns.isThisISOWeek(date2)
    ) {
      return "This Week"
    } else if (
      DateFns.isSameISOWeek(
        date1,
        DateFns.addWeeks(new Date(), 1)
      ) &&
      DateFns.isSameISOWeek(
        date2,
        DateFns.addWeeks(new Date(), 1)
      )
    ) {
      return "Next Week"
    } else if (
      DateFns.isSameISOWeek(
        date1,
        DateFns.addWeeks(new Date(), -1)
      ) &&
      DateFns.isSameISOWeek(
        date2,
        DateFns.addWeeks(new Date(), -1)
      )
    ) {
      return "Last Week"
    }
  } else if (DateFns.isSameDay(date1, date2)) {
    if (DateFns.isToday(date1)) {
      return "Today"
    } else if (DateFns.isTomorrow(date1)) {
      return "Tomorrow"
    } else if (DateFns.isYesterday(date1)) {
      return "Yesterday"
    } else {
      return DateFns.format(date1, "do MMM yy")
    }
  } else {
    return `${DateFns.format(
      date1,
      "do MMM yy"
    )} - ${DateFns.format(date2, "do MMM yy")}`
  }
  return `${DateFns.format(
    date1,
    "do MMM yy"
  )} - ${DateFns.format(date2, "do MMM yy")}`
}
